window.$ = window.jQuery;

Drupal.behaviors.checkWidth = {
  attach: function (context) {
    const $buttons = $('.list-view .sidebar__expandable-toggle', context);

    function checkWidth() {
      var windowSize = window.innerWidth;
      if (windowSize <= 1100) {
        $buttons.each(function () {
          const $button = $(this);
          const $parent = $button.parent();
          const $region = $('.sidebar__expandable-inside', $parent);
          const isExpanded = $button.attr('aria-expanded') === 'true';

          if (isExpanded) {
            $region.show();
          } else {
            $region.hide();
          }
        });
      }
    }
    
    const debounce = (callback, delay = 100) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          callback(...args);
        }, delay);
      };
    };
    
    checkWidth();
    
    const debounceCheck = debounce(checkWidth, 100);
    
    var cachedWidth = window.innerWidth;
    $(window).resize(function(){
      var newWidth = window.innerWidth;
      if(newWidth !== cachedWidth){
        debounceCheck();
        cachedWidth = newWidth;
      }
    });
  }
};

